import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ color }) => ({
  tooltip: {
    color: color.background.default,
  },
  tooltipContainer: {
    backgroundColor: color.foreground.default,
  },
  tooltipArrow: {
    color: color.foreground.default,
  },
  tooltipText: {
    whiteSpace: 'pre-line',
  },
}));
